<template>
    <div class="main">
        <div style="height: 80px; width: 100%; background-color: #f1f2f2; position: relative; text-align: center">
            <span style="font-size: 24px; font-weight: 600; line-height: 40px">{{ name }}</span>
            <br />
            <span style="font-size: 22px; font-weight: 600; line-height: 40px">详细视频拆解</span>
        </div>

        <div style="height: 100%; width: 100%">
            <a-table
                class="table"
                :columns="columnsFieldAverage1"
                :data-source="data_host"
                :bordered="true"
                :scroll="{ x: '100%' }"
                size="small"
                :pagination="false"
                :row-key="(record, index) => index"
                tableLayout="fixed"
            >
                <template v-for="item in columnsFieldAverage1" :key="item.key" #[item.key]="{ record, text }">
                    <span :class="hasVideo(text) ? 'num' : 'num_disable'" @click="showRow(record, item)">{{ text.value }}</span>
                </template>
            </a-table>
            <a-table
                class="table"
                :columns="columnsFieldAverage2"
                :data-source="data_host"
                :bordered="true"
                :scroll="{ x: '100%' }"
                size="small"
                :pagination="false"
                :row-key="(record, index) => index"
                tableLayout="fixed"
            >
                <template v-for="item in columnsFieldAverage2" :key="item.key" #[item.key]="{ record, text }">
                    <span :class="hasVideo(text) ? 'num' : 'num_disable'" @click="showRow(record, item)">{{ text.value }}</span>
                </template>
            </a-table>
        </div>
        <div style="margin-top: 10px; height: 0; width: 100%; background-color: #f1f2f2; position: relative">
            <!-- <span
                style="
                    font-size: 24px;
                    font-weight: 600;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%) translateX(-50%);
                    left: 50%;
                "
                >{{ guestName }}</span
            > -->
        </div>
        <div style="height: 100%; width: 100%">
            <a-table
                class="table"
                :columns="columnsAttack"
                :data-source="data_guest"
                :bordered="true"
                :scroll="{ x: '100%' }"
                size="small"
                :pagination="false"
                :row-key="(record, index) => index"
            >
                <template v-for="item in columnsAttack" :key="item.key" #[item.key]="{ record, text }">
                    <span :class="hasVideo(text) ? 'num' : 'num_disable'" @click="showRow(record, item)">{{ text.value }}</span>
                </template>
            </a-table>
        </div>

        <video-dialog
            :videoTitle="videoTitle"
            :visible="showVideo"
            :header="`https://k8-data-analysis.oss-cn-beijing.aliyuncs.com/`"
            :videos="videos"
            @close="close"
        />
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue'
import videoDialog from '@/components/videoDialog'
import { useRoute } from 'vue-router'

export default defineComponent({
    name: 'PanelData',
    components: {
        videoDialog,
    },
    props: {},
    setup() {
        const data_host = ref([])
        const data_guest = ref([])
        const showVideo = ref(false)

        const name = ref('')

        const videoTitle = ref()
        const videos = ref([])
        // onMounted(() => {
        const route = useRoute()

        name.value = route.query.name

        let field_average_data = require('../../assets/women-world-cup-personal-summary/personalSummary/field_average_data.json')
        data_host.value = [field_average_data[name.value]]
        let attack = require('../../assets/women-world-cup-personal-summary/personalSummary/attack.json')
        data_guest.value = attack[name.value]
        // })

        const close = () => {
            showVideo.value = false
        }
        const hasVideo = (item) => {
            return item.value > 0
        }
        const showRow = (record, item) => {
            videoTitle.value = name.value + '-' + item.title
            videos.value = []
            let timeObj = record[item.key].time
            Object.keys(timeObj).forEach((name) => {
                timeObj[name].forEach((item) => {
                    videos.value.push('2022女篮世界杯预选赛/' + name + '/' + item + '.mp4')
                })
            })
            showVideo.value = true
        }

        return {
            name,
            data_host,
            data_guest,
            showVideo,
            videoTitle,
            // match,
            // date,
            close,
            hasVideo,
            showRow,
            videos,
            // hostName,
            // guestName,
            // host,
            // guest,

            columnsFieldAverage1: [
                {
                    title: '得分',
                    key: 'score',
                    dataIndex: 'score',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'score' },
                },
                {
                    title: '两分出手',
                    key: 'TWOPA',
                    dataIndex: 'TWOPA',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'TWOPA' },
                },
                {
                    title: '两分命中',
                    key: 'TWOPM',
                    dataIndex: 'TWOPM',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'TWOPM' },
                },
                {
                    title: '两分不中',
                    key: 'TWOPm',
                    dataIndex: 'TWOPm',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'TWOPm' },
                },
                {
                    title: '两分%',
                    key: 'TWOperc',
                    dataIndex: 'TWOperc',
                    width: 60,
                    align: 'center',
                },
                {
                    title: '三分出手',
                    key: 'THREEPA',
                    dataIndex: 'THREEPA',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'THREEPA' },
                },
                {
                    title: '三分命中',
                    key: 'THREEPM',
                    dataIndex: 'THREEPM',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'THREEPM' },
                },
                {
                    title: '三分不中',
                    key: 'THREEPm',
                    dataIndex: 'THREEPm',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'THREEPm' },
                },
                {
                    title: '三分%',
                    key: 'THREEperc',
                    dataIndex: 'THREEperc',
                    width: 60,
                    align: 'center',
                },

                {
                    title: '罚球出手',
                    key: 'FTA',
                    dataIndex: 'FTA',
                    width: 60,
                    align: 'center',
                    // slots: { customRender: 'FTA' },
                },
                {
                    title: '罚球命中',
                    key: 'FTM',
                    dataIndex: 'FTM',
                    width: 60,
                    align: 'center',
                    // slots: { customRender: 'FTM' },
                },
                {
                    title: '罚球不中',
                    key: 'FTm',
                    dataIndex: 'FTm',
                    width: 60,
                    align: 'center',
                    // slots: { customRender: 'FTm' },
                },
                {
                    title: '罚球%',
                    key: 'FTperc',
                    dataIndex: 'FTperc',
                    width: 60,
                    align: 'center',
                },
            ],
            columnsFieldAverage2: [
                {
                    title: '前板',
                    key: 'OREB',
                    dataIndex: 'OREB',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'OREB' },
                },
                {
                    title: '后板',
                    key: 'DREB',
                    dataIndex: 'DREB',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'DREB' },
                },
                {
                    title: '总板',
                    key: 'TREB',
                    dataIndex: 'TREB',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'TREB' },
                },
                {
                    title: '助攻',
                    key: 'AST',
                    dataIndex: 'AST',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'AST' },
                },

                {
                    title: '抢断',
                    key: 'STL',
                    dataIndex: 'STL',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'STL' },
                },

                {
                    title: '失误',
                    key: 'TO',
                    dataIndex: 'TO',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'TO' },
                },

                {
                    title: '盖帽',
                    key: 'BLK',
                    dataIndex: 'BLK',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'BLK' },
                },

                {
                    title: '犯规',
                    key: 'FOUL',
                    dataIndex: 'FOUL',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'FOUL' },
                },
                {
                    title: '护框尝试',
                    key: 'DFGA',
                    dataIndex: 'DFGA',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'DFGA' },
                },

                {
                    title: '护框成功',
                    key: 'DFGM',
                    dataIndex: 'DFGM',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'DFGM' },
                },
                {
                    title: '护框失败',
                    key: 'DFGm',
                    dataIndex: 'DFGm',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'DFGm' },
                },
                {
                    title: '护框时对手命中率',
                    key: 'DFGperc',
                    dataIndex: 'DFGperc',
                    width: 120,
                    align: 'center',
                },
            ],
            columnsAttack: [
                {
                    title: '进攻方式',
                    dataIndex: 'PLAYTYPE',
                    key: 'PLAYTYPE',
                    width: 80,
                    align: 'center',
                    fixed: 'left',
                    customCell: () => {
                        return { style: { 'font-weight': '600' } }
                    },
                },
                {
                    title: '进攻机会',
                    dataIndex: 'PLAY',
                    key: 'PLAY',
                    width: 45,
                    align: 'center',
                    slots: { customRender: 'PLAY' },
                },
                {
                    title: '得分',
                    dataIndex: 'score',
                    key: 'score',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'score' },
                },
                {
                    title: '得分率',
                    dataIndex: 'SCOREperc',
                    key: 'SCOREperc',
                    width: 65,
                    align: 'center',
                },
                {
                    title: '篮下出手',
                    dataIndex: 'RA',
                    key: 'RA',
                    width: 45,
                    align: 'center',
                    slots: { customRender: 'RA' },
                },
                {
                    title: '篮下命中',
                    dataIndex: 'RM',
                    key: 'RM',
                    width: 45,
                    align: 'center',
                    slots: { customRender: 'RM' },
                },
                {
                    title: '篮下不中',
                    dataIndex: 'Rm',
                    key: 'Rm',
                    width: 45,
                    align: 'center',
                    slots: { customRender: 'Rm' },
                },
                {
                    title: '中距离\n出手',
                    dataIndex: 'MIDA',
                    key: 'MIDA',
                    width: 65,
                    align: 'center',
                    slots: { customRender: 'MIDA' },
                },
                {
                    title: '中距离\n命中',
                    dataIndex: 'MIDM',
                    key: 'MIDM',
                    width: 65,
                    align: 'center',
                    slots: { customRender: 'MIDM' },
                },
                {
                    title: '中距离\n不中',
                    dataIndex: 'MIDm',
                    key: 'MIDm',
                    width: 65,
                    align: 'center',
                    slots: { customRender: 'MIDm' },
                },
                {
                    title: '三分出手',
                    dataIndex: 'THREEPA',
                    key: 'THREEPA',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'THREEPA' },
                },
                {
                    title: '三分命中',
                    dataIndex: 'THREEPM',
                    key: 'THREEPM',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'THREEPM' },
                },
                {
                    title: '三分不中',
                    dataIndex: 'THREEPm',
                    key: 'THREEPm',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'THREEPm' },
                },
                // {
                //     title: '篮下比重',
                //     dataIndex: 'RRATIO',
                //     key: 'RRATIO',
                //     width: 65,
                //     align: 'center',
                // },
                // {
                //     title: '中距离\n比重',
                //     dataIndex: 'MIDRATIO',
                //     key: 'MIDRATIO',
                //     width: 65,
                //     align: 'center',
                // },
                // {
                //     title: '三分比重',
                //     dataIndex: 'THREERATIO',
                //     key: 'THREERATIO',
                //     width: 65,
                //     align: 'center',
                // },
                {
                    title: '有效命\n中率',
                    dataIndex: 'EFG',
                    key: 'EFG',
                    width: 65,
                    align: 'center',
                },
                {
                    title: '失误',
                    dataIndex: 'TO',
                    key: 'TO',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'TO' },
                },
                {
                    title: '失误率',
                    dataIndex: 'TORATIO',
                    key: 'TORATIO',
                    width: 65,
                    align: 'center',
                },
                {
                    title: '造罚球',
                    dataIndex: 'ZFQ',
                    key: 'ZFQ',
                    width: 60,
                    align: 'center',
                    slots: { customRender: 'ZFQ' },
                },
                {
                    title: '造罚球率',
                    dataIndex: 'FTRATIO',
                    key: 'FTRATIO',
                    width: 65,
                    align: 'center',
                },
            ],
        }
    },
})
</script>

<style lang="less" scoped>
.main {
    width: 100%;
    // height: 100%;
    overflow-y: scroll;
    padding: 50px 20px 60px;
    background: url('../../assets/bg_word_cup.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    @media screen and (max-width: 600px) {
        padding: 10px 10px 60px;
    }
}

.table {
    border-radius: 2px;
    background-color: white;
}

.num {
    color: #129cfe;
    cursor: pointer;
}

.num_disable {
    color: #333;
}
</style>
